import { TrafficCone } from 'lucide-react'
import InsightsPlaceholder from '~/assets/insights-placeholder.png'
import { Badge } from '~/elements'
import { cn } from '~/utils'

type InsightsCardProps = {
  className?: string
}

export const InsightsCard = ({ className }: InsightsCardProps) => {
  return (
    <div className={cn('relative rounded-lg border p-6', className)}>
      <h2 className="font-semibold">Insights</h2>
      <img src={InsightsPlaceholder} alt="Insights placeholder" className="blur-sm dark:hue-rotate-180 dark:invert" />
      <div className="absolute inset-0 flex items-center justify-center">
        <Badge className="flex h-8 w-fit gap-1.5 rounded-lg bg-gray-1" variant="outline">
          <TrafficCone size={16} />
          Coming Soon
        </Badge>
      </div>
    </div>
  )
}
